export default __webpack_public_path__ + "static/media/cosmetic-line.a8e7c205.webp";